module.exports = {
    en: {
        calculator: {
            oil: 'Gasoline/diesel',
            electric: 'Electric',
            hybrid: "Hybrid",
            left: "Left",
            right: "Right",
            single: "Single",
            double: "Double",
            cartype: "Car type",
            wheel: "Car steering wheel",
            decoration: "Car decoration",
            year: "Release year",
            engine: "Engine capacity",
            calcul: "Calculator"
        }

    },
    ka: {
        calculator: {
            oil: 'ბენზინი/დიზელი',
            electric: 'ელექტრო',
            hybrid: "ჰიბრიდი",
            left: "მარცხენა",
            right: "მარჯვენა",
            single: "ერთმაგი",
            double: "ორმაგი",
            cartype: "მანქანის ტიპი",
            wheel: "მანქანის საჭე",
            decoration: "მანქანის გაფორმება",
            year: "გამოშვების წელი",
            engine: "ძრავის მოცულობა",
            calcul: "კალკულატორი"
        }
    },
    ru: {
        calculator: {
            oil: 'Бензин/дизель',
            electric: 'Электрический',
            hybrid: "Гибридный",
            left: "слева",
            right: "справа",
            single: "Одинокий",
            double: "двойной",
            cartype: "тип автомобиля",
            wheel: "рулевое колесо автомобиля",
            decoration: "Украшение автомобиля",
            year: "Год выпуска",
            engine: "мощность двигателя",
            calcul: "калькулятор"
        }
    }
}